/** --------------------------------------------------------
* Author Tien Tran
* Email tientran0019@gmail.com
* Phone 0972970075
*
* Created: 2024-07-24 23:44:00

* Last updated on: 2024-07-24 23:44:00
* Last updated by: Tien Tran
*------------------------------------------------------- */

"use client";

import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import { SelectEventType } from "./select-event-type";

interface PropTypes {
	name: string;
}

export const RHFSelectEventType: React.FC<PropTypes> = (props) => {
	const { name } = props;
	const { control } = useFormContext();

	return (
		<Controller
			name={name}
			control={control}
			render={({ field, fieldState: { error } }) => {
				// eslint-disable-next-line @typescript-eslint/no-unused-vars
				const { ref, ...rest } = field;
				return <SelectEventType {...rest} error={error} />;
			}}
		/>
	);
};
